"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerSizeEnum = exports.MenuButtonsEnum = exports.HomePageSectionsEnum = exports.SportsbookGameItemTypeEnum = exports.SportsbookLayoutEnum = exports.CasinoLayoutEnum = exports.ProfileLayoutEnum = exports.HeaderLayoutEnum = exports.WalletLayoutEnum = exports.LoginLayoutEnum = exports.SignupLayoutEnum = exports.LayoutEnum = void 0;
var LayoutEnum;
(function (LayoutEnum) {
    LayoutEnum["Default"] = "default";
    LayoutEnum["Compact"] = "compact";
})(LayoutEnum || (exports.LayoutEnum = LayoutEnum = {}));
var SignupLayoutEnum;
(function (SignupLayoutEnum) {
    SignupLayoutEnum["Default"] = "default";
    SignupLayoutEnum["CPFSignup"] = "cpf_signup";
    SignupLayoutEnum["CPFSignup1Step"] = "cpf_signup_1step";
    SignupLayoutEnum["CPFSignupKyc"] = "cpf_signup_kyc";
    SignupLayoutEnum["Afro"] = "afro";
})(SignupLayoutEnum || (exports.SignupLayoutEnum = SignupLayoutEnum = {}));
var LoginLayoutEnum;
(function (LoginLayoutEnum) {
    LoginLayoutEnum["Compact"] = "compact";
    LoginLayoutEnum["AfroCompact"] = "afro_compact";
})(LoginLayoutEnum || (exports.LoginLayoutEnum = LoginLayoutEnum = {}));
var WalletLayoutEnum;
(function (WalletLayoutEnum) {
    WalletLayoutEnum["Default"] = "default";
    WalletLayoutEnum["Pix"] = "pix";
    WalletLayoutEnum["Tola"] = "tola";
    WalletLayoutEnum["MultiWallet"] = "multiwallet";
})(WalletLayoutEnum || (exports.WalletLayoutEnum = WalletLayoutEnum = {}));
var HeaderLayoutEnum;
(function (HeaderLayoutEnum) {
    HeaderLayoutEnum["V1"] = "v1";
    HeaderLayoutEnum["V2"] = "v2";
})(HeaderLayoutEnum || (exports.HeaderLayoutEnum = HeaderLayoutEnum = {}));
var ProfileLayoutEnum;
(function (ProfileLayoutEnum) {
    ProfileLayoutEnum["Default"] = "default";
    ProfileLayoutEnum["Compact"] = "compact";
})(ProfileLayoutEnum || (exports.ProfileLayoutEnum = ProfileLayoutEnum = {}));
var CasinoLayoutEnum;
(function (CasinoLayoutEnum) {
    CasinoLayoutEnum["Compact"] = "compact";
    CasinoLayoutEnum["GameStore"] = "gamestore";
})(CasinoLayoutEnum || (exports.CasinoLayoutEnum = CasinoLayoutEnum = {}));
var SportsbookLayoutEnum;
(function (SportsbookLayoutEnum) {
    SportsbookLayoutEnum["Default"] = "default";
    SportsbookLayoutEnum["Flat"] = "flat";
})(SportsbookLayoutEnum || (exports.SportsbookLayoutEnum = SportsbookLayoutEnum = {}));
var SportsbookGameItemTypeEnum;
(function (SportsbookGameItemTypeEnum) {
    SportsbookGameItemTypeEnum["Default"] = "default";
    SportsbookGameItemTypeEnum["Flex"] = "flex";
})(SportsbookGameItemTypeEnum || (exports.SportsbookGameItemTypeEnum = SportsbookGameItemTypeEnum = {}));
var HomePageSectionsEnum;
(function (HomePageSectionsEnum) {
    HomePageSectionsEnum["Banners"] = "banners";
    HomePageSectionsEnum["LiveCasino"] = "livecasino";
    HomePageSectionsEnum["Slots"] = "slots";
    HomePageSectionsEnum["Sport"] = "sport";
    HomePageSectionsEnum["PrematchTop"] = "prematch_top";
    HomePageSectionsEnum["PrematchUpcoming"] = "prematch_upcoming";
    HomePageSectionsEnum["LiveUpcoming"] = "live_upcoming";
    HomePageSectionsEnum["Reels"] = "reels";
})(HomePageSectionsEnum || (exports.HomePageSectionsEnum = HomePageSectionsEnum = {}));
var MenuButtonsEnum;
(function (MenuButtonsEnum) {
    MenuButtonsEnum["Live"] = "live";
    MenuButtonsEnum["Prematch"] = "prematch";
    MenuButtonsEnum["BetSlip"] = "bet_slip";
    MenuButtonsEnum["Casino"] = "casino";
    MenuButtonsEnum["CasinoTools"] = "casino_tools";
    MenuButtonsEnum["Slots"] = "slots";
    MenuButtonsEnum["LiveCasino"] = "livecasino";
})(MenuButtonsEnum || (exports.MenuButtonsEnum = MenuButtonsEnum = {}));
var BannerSizeEnum;
(function (BannerSizeEnum) {
    BannerSizeEnum["Narrow"] = "narrow";
    BannerSizeEnum["Medium"] = "medium";
    BannerSizeEnum["Max"] = "max";
})(BannerSizeEnum || (exports.BannerSizeEnum = BannerSizeEnum = {}));
//# sourceMappingURL=layouts.js.map